<template>
  <div class="page-wrapper home-container">
    <img src="../../public/img/lico.png" />
    <div>
    <div class="home-header">
      <div class="display-text">
        Conicle design system
      </div>
      <div class="heading-text">
        Making Conicle looks and feels like Conicle
      </div>
      </div>
    </div>
    <div class="menu-card-container">
      <a @click="navigateTo('/brand')" class="menu-card" ><p class="card-title">🎨 Brand</p><p class="card-desc">Design language and standardized approach to deliver cohesive brand experiences</p><CncIconButton type="neutral" size="small" :iconName="{type: 'svg', name: 'IconArrowChevronRight'}" /></a>
      <a @click="navigateTo('/foundations')" class="menu-card"><p class="card-title">📐 Foundations</p><p class="card-desc">The fundamental parts of the UI design system that underpin all of our platform interfaces</p><CncIconButton type="neutral" size="small" :iconName="{type: 'svg', name: 'IconArrowChevronRight'}" /></a>
      <a @click="navigateTo('/components')" class="menu-card"><p class="card-title">🧩 Components</p><p class="card-desc">Reusable building blocks of the UI design system for creating patterns and intuitive user experiences</p><CncIconButton type="neutral" size="small" :iconName="{type: 'svg', name: 'IconArrowChevronRight'}" /></a>
      <a @click="navigateTo('/resources')" class="menu-card"><p class="card-title">📦 Resources</p><p class="card-desc">Downloadable assets for branding and product representation</p><CncIconButton type="neutral" size="small" :iconName="{type: 'svg', name: 'IconArrowChevronRight'}" /></a>
      <a @click="navigateTo('/knowledges')" class="menu-card"><p class="card-title">💡 Knowledges</p><p class="card-desc">Shared knowledges about our products, designs, and businesses</p><CncIconButton type="neutral" size="small" :iconName="{type: 'svg', name: 'IconArrowChevronRight'}" /></a>
    </div>
    <div class="footer-text">
      This site was built with love by the UXUI, branding, and front-end teams at Conicle. <span class="emoji">🫰</span>
      <br>
      For any questions, feel free to <a @click="navigateTo('/home/getting-started/basics/contact-us')">contact us.</a>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    navigateTo (path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss">

.home-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;

  img {
    width: 500px;
    margin-bottom: -64px;
  }
  .home-header {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    margin-bottom: 32px;

    .display-text {
      text-align: center;
      font: $font-style-display-xl-bold;
      color: $color-cool-grey-900;
    }

    .heading-text {
      text-align: center;
      font: $font-style-heading-md-reg;
      color: $color-cool-grey-700;
    }
  }

  .footer-text {
    margin-top: 32px;
    text-align: center;
    font: $font-style-functional-lg-reg;
    color: $color-cool-grey-700;

    a {
      cursor: pointer;
      color: $color-primary-500;
      font: $font-style-functional-lg-reg;
    }
  }

  .menu-card-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 16px;
    row-gap: 16px;
    justify-content: flex-start;

    .menu-card {
      flex: 0 1 calc((100% - (16px * 1)) / 2);
      border-radius: 16px;
      padding: 20px 20px;
      border: 1px solid $color-cool-grey-100;
      display: flex;
      flex-direction: column;
      gap: 6px;
      align-items: flex-end;
      box-sizing: border-box;

      @media screen and (max-width: 559px) {
        flex: 1 1 100%;
      }

      p {
        padding: 0;
        margin: 0;
        align-self: stretch;
      }

      .card-title {
      font: $font-style-title-lg-med;
      color: $color-cool-grey-900;
      };

      .card-desc {
      font: $font-style-functional-lg-reg;
      color: $color-cool-grey-700;
      }

      .cnc-icon-button {

        pointer-events: none;

        svg path {
          fill: $color-cool-grey-500;
        }
      }

      &:hover {
        background-color: $color-cool-grey-50;
        color: $color-cool-grey-900;
        border-color: $color-cool-grey-50;
      }
    }
  }
}

.emoji {
  font-size: 1.4em;
  vertical-align: middle;
}

</style>
